class BlogArticleTracker {
  static STORAGE_KEY = "blog_read_articles";
  static TWO_DAYS_IN_MS = 2 * 24 * 60 * 60 * 1000;

  static markAsRead(articleId) {
    if (!articleId) return;

    const readArticles = this.getReadArticles();
    const now = Date.now();
    const articleData = {
      id: articleId,
      timestamp: now,
    };

    if (!readArticles.some((article) => article.id === articleId)) {
      readArticles.push(articleData);
      this.cleanupOldArticles();
      this.saveReadArticles(readArticles);
      this.updateHeaderLinks();
    }
  }

  static cleanupOldArticles() {
    const readArticles = this.getReadArticles();
    const now = Date.now();
    const currentArticles = readArticles.filter(
      (article) => now - article.timestamp <= this.TWO_DAYS_IN_MS
    );
    this.saveReadArticles(currentArticles);
  }

  static getReadArticles() {
    try {
      return JSON.parse(localStorage.getItem(this.STORAGE_KEY) || "[]");
    } catch {
      return [];
    }
  }

  static saveReadArticles(articles) {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(articles));
    } catch (error) {
      // エラー時は静かに失敗
    }
  }

  static isArticleRead(articleId) {
    const readArticles = this.getReadArticles();
    const article = readArticles.find((article) => article.id === articleId);
    if (!article) return false;
    return Date.now() - article.timestamp <= this.TWO_DAYS_IN_MS;
  }

  static updateHeaderLinks() {
    const blogLinks = document.querySelectorAll(".js-blog-link");
    blogLinks.forEach((link) => {
      const listItem = link.closest("li");
      if (!listItem?.dataset.blogHandle) return;

      if (
        this.hasUnreadRecentArticles(
          listItem.dataset.blogHandle,
          listItem.dataset.recentArticles
        )
      ) {
        link.classList.add("c-blog-new__link");
      } else {
        link.classList.remove("c-blog-new__link");
      }
    });
  }

  static hasUnreadRecentArticles(blogHandle, recentArticles) {
    if (!recentArticles) return false;

    return recentArticles
      .split(",")
      .filter(Boolean)
      .some((articleId) => !this.isArticleRead(articleId));
  }
}

// 初期化処理
document.addEventListener("DOMContentLoaded", () => {
  BlogArticleTracker.cleanupOldArticles();
  const articleId = document
    .querySelector(".article")
    ?.getAttribute("data-article-id");
  if (articleId) {
    BlogArticleTracker.markAsRead(articleId);
  }
  BlogArticleTracker.updateHeaderLinks();
});

// 1時間ごとにクリーンアップ
setInterval(() => {
  BlogArticleTracker.cleanupOldArticles();
}, 60 * 60 * 1000);
